/**
 * 卡位人物素材的路径解析(2026-07-23 卡片重构 R2)。
 *
 * ★为什么不往 catalog 加常量:93 张素材 = 23 卡 × 3 皮肤 + 部门卡/hero,写进 catalog 就是
 * 69 条重复常量,而且切皮肤时要手工对齐。这里按 `data-skin` 现算,切皮肤自动换人。
 *
 * ★为什么是 WebP 不是 PNG:场景烘进图里之后 PNG 压不动 —— 384px 单张 150KB,
 * 93 张 14MB,爆预算 6 倍;WebP q90 同尺寸 15~18KB,全量约 1.6MB,肉眼无差。
 *
 * ★缺图降级:消费端一律用 `background-image` 而**不是** `<img>+onError` ——
 * 后者在图 404 时会先闪一次 alt 文本再消失,`background-image` 直接什么都不显示,
 * 卡片其余部分照常(验收判据 §2:人物图 404 时卡片正常显示,只是没人物)。
 */
import type { ThemeKey } from "@/shared/hooks/useTheme";

/** 卡位人物:`/scene-figures/<skin>/<cardKey>.webp`。 */
export const figureOf = (skin: ThemeKey, key: string) => `/scene-figures/${skin}/${key}.webp`;

/** 能力舱卡位人物:`/scene-figures/<skin>/cap-<capability>.webp`(2026-07-27 首页/群页挂小人)。 */
export const capFigureOf = (skin: ThemeKey, capability: string) =>
  `/scene-figures/${skin}/cap-${capability}.webp`;

/** 工作台部门卡双人图:`/scene-figures/<skin>/dept-<deptKey>.webp`。 */
export const deptFigureOf = (skin: ThemeKey, deptKey: string) =>
  `/scene-figures/${skin}/dept-${deptKey}.webp`;

/** hub 页头 hero 整屏场景图:`/scene-figures/<skin>/hero-<hub>.webp`。 */
export const heroFigureOf = (skin: ThemeKey, hub: string) =>
  `/scene-figures/${skin}/hero-${hub}.webp`;
